import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SamoobslugaService} from '../../../../shared/services/samoobsluga/samoobsluga.service';
import {map, mergeMap} from 'rxjs/operators';
import {zip} from 'rxjs';
import {Injectable} from '@angular/core';
import {kliknietoDodanjDokumenty} from './ekran-koncowy.actions';
import {NavigationService} from '../../../services/navigation/navigation.service';

@Injectable()
export class EkranKoncowyEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly samoobslugaService: SamoobslugaService,
    private readonly navigationService: NavigationService
  ) {}

  kliknietoDodanoDokumenty$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(kliknietoDodanjDokumenty),
        mergeMap(({correlationId}) => {
          return zip(this.samoobslugaService.pobierzLinkDokumentacji(correlationId));
        }),
        map(([linkDokumentacja]) => {
            const link = linkDokumentacja.link;
            link ? this.navigationService.navigateToExternalUrl(link) : this.navigationService.navigate(['/dokumentyKontakt'])
        })
      ), {dispatch: false}
  );

}
